import { NgModule }             from "@angular/core";
import { SearchPage }           from "./search";
import { RouterModule }         from "@angular/router";
import { FormsModule }          from "@angular/forms";
import { CommonModule }         from "@angular/common";
import { MatButtonModule }      from "@angular/material/button";
import { CaptionPipe }          from "../../pipes/caption.pipe";
import { GetFiletypeIconPipe }  from "../../pipes/get-filetype-icon.pipe";
import { LanguageByIsoCodePipe } from "../../pipes/languageByIsoCode.pipe";
import { NodePipe } from "../../pipes/node.pipe";
import { TranslatePipe } from "../../pipes/translate";
import { FilesizePipe } from "../../pipes/filesize";

@NgModule({
	declarations: [
		SearchPage
	],
	imports: [
		CommonModule,
		FormsModule,
		RouterModule.forChild([
			{
				path: "",
				component: SearchPage
			}
		]),
		MatButtonModule,
		CaptionPipe,
		GetFiletypeIconPipe,
		LanguageByIsoCodePipe,
		NodePipe,
		TranslatePipe,
		FilesizePipe
	]
})
export class SearchPageModule {
}
